<template>
    <div :key="queueID">
        {{getCallersCount}}
    </div>
</template>
<script>
    import get from 'lodash/get'
    import { ALL_QUEUE_ID, QUEUE_RULE_NO_RULE } from '@/enum/queueDashboardStatistics'

    export default {
        props: {
            queueID: {
                type: [Number, String],
                default: null
            },
            queueRuleID: {
                type: [Number, String],
                default: null
            },
            queueName: {
                type: String
            }
        },
        computed: {
            getQueueByID () {
                return this.$store.getters['queues/filterQueuesByIds']([this.queueID])
            },
            allQueueCalls () {
                return this.$store.getters['queues/allQueueCalls']
            },
            getCallersCount () {
                if (this.queueID === ALL_QUEUE_ID) {
                    return this.allQueueCalls.length
                }

                let queueData = this.getQueueByID

                const queueCalls = get(queueData, '[0].Calls', [])

                if (this.queueRuleID === QUEUE_RULE_NO_RULE) {
                    return queueCalls.filter(call => !call.queueRule).length
                } else if (this.queueRuleID !== null) {
                    return queueCalls.filter(call => Number(call.queueRule) === Number(this.queueRuleID)).length
                }

                return queueCalls.length
            }
        },
        watch: {
            getCallersCount: {
                immediate: true,
                handler (val) {
                    if (this.queueID !== ALL_QUEUE_ID) {
                        this.$emit('getCallerCount', {
                            value: val,
                            queueID: this.queueID,
                            queueName: this.queueName
                        })
                    }
                }
            }
        }
    }
</script>
